import { Routes } from '@angular/router';

import { HomeComponent } from './public/components/home.component';
import { AcademicCalenderComponent } from './public/components/academic-calender.component';
import { AchievementsComponent } from './public/components/achievements.component';
import { AnyOthersComponent } from './public/components/any-others.component';
import { BalajiInsuranceComponent } from './public/components/balaji-insurance.component';
import { BalajiSevasamithiComponent } from './public/components/balaji-sevasamithi.component';
import { CampusBuildingsComponent } from './public/components/campus-buildings.component';
import { CollegeFeeComponent } from './public/components/college-fee.component';
import { CollegeComponent } from './public/components/college.component';
import { CoursesOfferedAndAdmissionsComponent } from './public/components/courses-offered-and-admissions.component';
import { CurriculumComponent } from './public/components/curriculum.component';
import { DepartmentsComponent } from './public/components/departments.component';
import { DirectoryComponent } from './public/components/directory.component';
import { DisciplinesAndDepartmentsComponent } from './public/components/disciplines-and-departments.component';
import { EnrollNowComponent } from './public/components/enroll-now.component';
import { EventsComponent } from './public/components/events.component';
import { FinancialAidComponent } from './public/components/financial-aid.component';
import { GrievanceReddressalCommitteeComponent } from './public/components/grievance-reddressal-committee.component';
import { HealthCentreComponent } from './public/components/health-centre.component';
import { HostelComponent } from './public/components/hostel.component';
import { InstitutionIndustryCellComponent } from './public/components/institution-industry-cell.component';
import { InternalComplaintsCommitteeComponent } from './public/components/internal-complaints-committee.component';
import { InternalQualityAssuranceCommitteeComponent } from './public/components/internal-quality-assurance-committee.component';
import { LabsComponent } from './public/components/labs.component';
import { LibraryComponent } from './public/components/library.component';
import { ManagementComponent } from './public/components/management.component';
import { PlayGroundComponent } from './public/components/play-ground.component';
import { PrincipalComponent } from './public/components/principal.component';
import { ProfileComponent } from './public/components/profile.component';
import { PublicationsComponent } from './public/components/publications.component';
import { QualityParametersComponent } from './public/components/quality-parameters.component';
import { ResearchComponent } from './public/components/research.component';
import { ScAndStGrievanceCommitteeComponent } from './public/components/sc-and-st-grievance-committee.component';
import { ScholarshipsComponent } from './public/components/scholarships.component';
import { SportsComponent } from './public/components/sports.component';
import { SriBalajiEducationalSocietyComponent } from './public/components/sri-balaji-educational-society.component';
import { TeachingAndNonteachingComponent } from './public/components/teaching-and-nonteaching.component';
import { TestimonialsComponent } from './public/components/testimonials.component';
import { TransportAndParkingComponent } from './public/components/transport-and-parking.component';
import { AntiRaggingCommitteeComponent } from './public/components/anti-ragging-committee.component';
import { AboutComponent } from './public/components/about.component';
import { AcademicsComponent } from './public/components/academics.component';
import { InfrastructureAnyOthersComponent } from './public/components/infrastructure-any-others.component';
import { FacultyAnyOthersComponent } from './public/components/faculty-any-others.component';
import { FacultyComponent } from './public/components/faculty.component';
import { GalleryComponent } from './public/components/gallery.component';
import { ContactComponent } from './public/components/contact.component';
import { FounderComponent } from './public/components/founder.component';
import { ChairmanComponent } from './public/components/chairman.component';
import { DirectorComponent } from './public/components/director.component';
import { SpecialOfficerComponent } from './public/components/specialofficer.component';
import { RepresentativeComponent } from './public/components/representative.component';
import { AlumniComponent } from './public/components/alumni.component';
import { InfrastructureComponent } from './public/components/infrastructure.component';
import { MandatorydisclosuresComponent } from './public/components/mandatorydisclosures.component';
import { GrievancePortalComponent } from './public/components/grievance-portal.component';



export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
  },

  /*about*/
  {
    path: 'about',
    component: AboutComponent,
    children: [
      { path: '', redirectTo: 'college', pathMatch: 'full' },
      { path: 'college', component: CollegeComponent },
      { path: 'management', component: ManagementComponent },
      { path: 'founder', component: FounderComponent },
      { path: 'sri-balaji-educational-society', component: SriBalajiEducationalSocietyComponent },
      { path: 'balaji-sevasamithi', component: BalajiSevasamithiComponent },
      { path: 'balaji-insurance', component: BalajiInsuranceComponent },
      { path: 'principal', component: PrincipalComponent },
      { path: 'chairman', component: ChairmanComponent },
      { path: 'director', component: DirectorComponent },
      { path: 'special-officer', component: SpecialOfficerComponent },
      { path: 'representative', component: RepresentativeComponent }
    ]
  },

  /* ACADEMICS */
  {
    path: 'academics',
    component: AcademicsComponent,
    children: [
      { path: '', redirectTo: 'disciplines-and-departments', pathMatch: 'full' },
      { path: 'disciplines-and-departments', component: DisciplinesAndDepartmentsComponent },
      { path: 'courses-offered-and-admissions', component: CoursesOfferedAndAdmissionsComponent },
      { path: 'college-fee', component: CollegeFeeComponent },
      { path: 'scholarships', component: ScholarshipsComponent },
      { path: 'financial-aid', component: FinancialAidComponent },
      { path: 'curriculum', component: CurriculumComponent },
      { path: 'academic-calender', component: AcademicCalenderComponent },
      { path: 'quality-parameters', component: QualityParametersComponent },
      { path: 'any-others', component: AnyOthersComponent }
    ]
  },

  /* FACULTY */
  {
    path: 'faculty',
    component: FacultyComponent,
    children: [
      { path: '', redirectTo: 'departments', pathMatch: 'full' },
      { path: 'departments', component: DepartmentsComponent },
      { path: 'teaching-and-nonteaching', component: TeachingAndNonteachingComponent },
      { path: 'profile', component: ProfileComponent },
      { path: 'publications', component: PublicationsComponent },
      { path: 'research', component: ResearchComponent },
      { path: 'achievements', component: AchievementsComponent },
      { path: 'any-others', component: FacultyAnyOthersComponent }
    ]
  },

  /* INFRASTRUCTURE */
  {
    path: 'infra',
    component: InfrastructureComponent,
    children: [
      { path: '', redirectTo: 'campus-buildings', pathMatch: 'full' },
      { path: 'campus-buildings', component: CampusBuildingsComponent },
      { path: 'library', component: LibraryComponent },
      { path: 'labs', component: LabsComponent },
      { path: 'play-ground', component: PlayGroundComponent },
      { path: 'hostel', component: HostelComponent },
      { path: 'events', component: EventsComponent },
      { path: 'sports', component: SportsComponent },
      { path: 'health-centre', component: HealthCentreComponent },
      { path: 'transport-and-parking', component: TransportAndParkingComponent },
      { path: 'any-others', component: InfrastructureAnyOthersComponent },
    ]
  },

  /* ALUMNI */
  {
    path: 'alumni',
    component: AlumniComponent,
    children: [
      { path: '', redirectTo: 'directory', pathMatch: 'full' },
      { path: 'directory', component: DirectoryComponent },
      { path: 'enroll-now', component: EnrollNowComponent },
      { path: 'testimonials', component: TestimonialsComponent }
    ]
  },
  

  /* GALLERY & CONTACT */
  { path: 'gallery', component: GalleryComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'mandatory-disclosure', component: MandatorydisclosuresComponent },
  { path: 'grievance-portal', component: GrievancePortalComponent },



  /* COMMITTEES */
  { path: 'anti-ragging-committee', component: AntiRaggingCommitteeComponent },
  { path: 'grievance-reddressal-committee', component: GrievanceReddressalCommitteeComponent },
  { path: 'internal-complaints-committee', component: InternalComplaintsCommitteeComponent },
  { path: 'sc-and-st-grievance-committee', component: ScAndStGrievanceCommitteeComponent },
  { path: 'internal-quality-assurance-committee', component: InternalQualityAssuranceCommitteeComponent },
  { path: 'institution-industry-cell', component: InstitutionIndustryCellComponent },
];
